import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class LibraryAdd extends React.Component {

  static contextTypes = {
    modal: PropTypes.object
  }

  static propTypes = {
    entity: PropTypes.string,
    record: PropTypes.object,
    scope: PropTypes.string,
    type: PropTypes.string,
    onCancel: PropTypes.func
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleSuccess = this._handleSuccess.bind(this)

  render() {
    return <Form { ...this._getForm() } />
  }

  _getForm() {
    const { entity, record, scope } = this.props
    return {
      title: 't(Add to Library)',
      endpoint: `/api/admin/truevail/${scope}/${entity}/${record.id}/edit`,
      action: `/api/admin/truevail/${scope}/${entity}/${record.id}/publish`,
      method: 'PATCH',
      onCancel: this._handleCancel,
      onSuccess: this._handleSuccess,
      sections: [
        {
          fields: [
            { 
              label: 't(Library Details)',
              type: 'segment',
              fields: [
                { 
                  label: 't(Folders)', 
                  entity: 'folder',
                  name: 'folder_ids', 
                  type: 'checkboxgroup', 
                  endpoint: `/api/admin/truevail/${scope}/folders`, 
                  valueKey: 'id', 
                  textKey: 'title' 
                },
                { 
                  label: 't(Tags)', 
                  name: 'tags', 
                  type: 'tagfield', 
                  endpoint: '/api/admin/tags' 
                }
              ]
            }
          ]
        }
      ]
    }
  }

  _handleCancel() {
    this.context.modal.close()
  }

  _handleSuccess() {
    this.context.modal.close()
  }

}

export default LibraryAdd
